import { css } from '@emotion/react';

import { COLORS, FONT_SIZE, FONT_WEIGHT } from '~/configs/theme.ts';

import type { CSSProperties, PropsWithChildren } from 'react';

export interface BodyProps extends PropsWithChildren {
  className?: string;
  color?: string;
  fontWeight?: Lowercase<keyof typeof FONT_WEIGHT>;
  size?: 'small' | 'medium' | number;
  style?: CSSProperties;
}

function Body({
  children,
  color = COLORS.GRAY['700'],
  className,
  fontWeight = 'regular',
  size = 'small',
  style = {},
}: BodyProps) {
  return (
    <div
      className={className}
      css={[styles.base(fontWeight), typeof size === 'string' ? styles[size] : styles.size(size)]}
      style={{ color, ...style }}
    >
      {children}
    </div>
  );
}

const styles = {
  base: (fontWeight: Lowercase<keyof typeof FONT_WEIGHT>) => css`
    font-weight: ${FONT_WEIGHT[fontWeight.toUpperCase() as keyof typeof FONT_WEIGHT]};
    font-style: normal;
    line-height: 140%;
    white-space: pre-wrap;
  `,

  size: (fontSize: number) => css`
    font-size: ${fontSize}px;
  `,

  small: css`
    font-size: ${FONT_SIZE['14']};
  `,

  medium: css`
    font-size: ${FONT_SIZE['16']};
  `,
};

export default Body;
